<template lang='pug'>
  el-menu.el-menu-vertical-admin(default-active='2', @open='handleOpen',
    @close='handleClose',active-text-color='#ffd04b')
    el-menu-item(index='1-4', @click='addNewUniversity')
      i.el-icon-circle-plus
      span Διαχειριστικό Ιδρυμάτων (Νέων)
    el-menu-item(index='1-3', @click='addUniversity')
      i.el-icon-circle-plus
      span Διαχειριστικό Ιδρυμάτων (Παλιών)
    el-menu-item(index='1003', @click='toggleUniSearch')
      template(slot='title')
        i.el-icon-search
        span Αναζήτηση Ιδρυμάτων
</template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
    toggleUniSearch () {
      this.$store.dispatch('SHOW_HIDE_UNISEARCH')
    },
    addUniversity () {
      this.$emit('addUniversity')
    },
    addNewUniversity () {
      this.$emit('addNewUniversity')
    },
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    }
  }
}
</script>

<style lang='scss' scoped>
.is-active {
  color: blue;
}
.el-submenu {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
  &__title:hover {
    background-color: "#b3c0d1";
  }
}
.el-menu-vertical-admin {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/RegistryAdminMenu.vue